// dependecies
import React from "react";
import { useParams } from "react-router-dom";

import { faStar } from "@fortawesome/pro-solid-svg-icons";

import { Text } from "@performyard/py-components";

//components
import { Divider } from "../../../../../components/Divider";
import Icon from "../../../../../components/Icon/Icon";
import Spacer from "../../../../../components/Spacer";
import ExpandableGoalDescription from "../SingleGoalInfo/components/ExpandableGoalDescription";
import GoalDetailsOptionsDropdown from "./components/GoalDetailsOptionsDropdown";

//services
import { useGoalDetails } from "../../../../../api/hooks";
//hooks
import usePageWidthBreakpoint from "../../../../../hooks/usePageWidthBreakpoint";

import { Goal } from "../../../../../api/services";

//css
import css from "./SingleGoalHeader.module.scss";

const SingleGoalHeader = () => {
	const { isTablet, isMobile } = usePageWidthBreakpoint();
	const isMobileLayout = isMobile || isTablet;
	const { goal_id: goalId } = useParams<{ goal_id: string }>();
	const { data } = useGoalDetails({ goalID: goalId || "" });
	const goal = data ? data.goal : ({} as Goal);

	return (
		<div className={css.singleGoalHeader}>
			<div className={css.goalNameRow}>
				<div className={`${css.goalName} min-w-0`}>
					{goal?.is_top && (
						<div className={css.goalIcon}>
							<Icon
								testid={faStar.iconName}
								icon={faStar}
								color="yellow-5"
								useToolTip={"always"}
								toolTipText={"This is a top-level goal and should appear at the top of your goal tree"}
							/>
						</div>
					)}
					<Text
						wrap={false}
						size="heading-5"
						weight="semi-bold"
						dangerouslySetClassName="py-text-truncate min-w-0"
					>
						{goal?.name}
					</Text>
				</div>
				{!isMobileLayout && <GoalDetailsOptionsDropdown />}
			</div>
			<Spacer height={1} />
			<div className={css.goalDescription}>
				<ExpandableGoalDescription descriptionMarkdown={goal?.description} />
			</div>
			{isMobileLayout && (
				<div>
					<Divider />
					<Spacer height={1} />
					<GoalDetailsOptionsDropdown />
				</div>
			)}
		</div>
	);
};

export default SingleGoalHeader;
